import React from 'react';
import { mergeProps } from "../../Utils/mergeProps";

const ChrInfoPopoverTemplate = (props) => {
  const wrapperOptions = mergeProps({ className: "popover", role: "tooltip" }, props.wrapperOptions || {});
  const headerOptions = mergeProps({ className: "popover-header" }, props.headerOptions || {});
  const bodyOptions = mergeProps({ className: "popover-body" }, props.bodyOptions || {});

  return(
    <div {...wrapperOptions} role="tooltip">
      <div className="arrow"></div>
      <h3 {...headerOptions}></h3>
      <div {...bodyOptions}></div>
    </div>
  );
};

export default ChrInfoPopoverTemplate;